const SectionAbout = Class(
	/**
	 * @lends {SectionAbout#}
	 */
	{
		menuItem: 'about',
		draw: function() {
			const members = [
				'liene',
				'haralds',
				'deniels',
				'karlis',
				'lauris',
				'juta',
				'zane',
				'everts',
				'gustavs',
				'janis',
				'davis',
				'luize',
				'valters',
			];

			if (D.CSS.brTablet) {
				members.unshift('team');
			}

			this.node = mkE({
				tag: 'div',
				id: 'SectionAbout',
				els: [
					{
						tag: 'div',
						id: 'hero',
						className: 'container py-5',
						els: [
							{
								tag: 'div',
								els: [
									{
										tag: 'div',
										className: 'hero__phone'
									},
									{
										tag: 'h1',
										text: t('b2b.about.hero.h3')
									},
									{
										tag: 'p',
										text: t('b2b.about.hero.p')
									},
									{
										tag: 'div',
										className: 'hero__btn',
										els: [
											{
												tag: 'a',
												className: 'button button-pink',
												href: D.url('/contact-us?ref=about'),
												text: t('b2b.about.hero.btn')
											}
										]
									}
								]
							}
						]
					},
					{
						tag: 'div',
						className: 'container mb-5 about__team',
						els: [
							{
								tag: 'h2',
								text: t('b2b.about.h1')
							},
							{
								tag: 'p',
								text: t('b2b.about.p')
							},
							this._teamNode = mkE({
								tag: 'div',
								className: 'team',
								els: (function() {
									let els = [];
									for (let i = 0; i < members.length; i++) {
										const member = members[i];
										els.push({
											tag: 'div',
											className: 'team__member ' + (D.CSS.brTablet ? '' : 'fade'),
											els: [
												{
													tag: 'div',
													className: `team__member__portrait portrait-${member}`,
													els: [
														{
															tag: 'div',
															className: 'img'
														},
														member === 'team' ? '' : {
															tag: 'div',
															className: 'h1',
															text: member
														}
													]
												},
												{
													tag: 'div',
													className: 'team__member__bubble',
													els: [
														{
															tag: 'div',
															className: 'h4',
															text: t(`b2b.about.members.${member}.title`)
														},
														{
															tag: 'p',
															text: t(`b2b.about.members.${member}.about`)
														}
													]
												}
											]
										});
									}
									return els;
								})()
							})
						]
					},
					{
						tag: 'div',
						className: 'container text-center about__bottom',
						els: [
							{
								tag: 'div',
								className: 'h1 mb-5',
								text: t('b2b.about.bottom.text')
							},
							{
								tag: 'div',
								className: 'mb-5',
								els: [
									{
										tag: 'a',
										className: 'button button-turquoise',
										href: D.url(t('b2b.about.bottom.link')),
										text: t('b2b.about.bottom.btn')
									}
								]
							}
						]
					}
				]
			}).append(this.layout.ct());

			this.ready();
		},

		onShow() {
			this.fadeOnShow();
		},

		onScroll() {
			this.fadeOnScroll();
		}

	},
	Section
);
